;
//mogelijk voorbeeld hier: https://blog.thinkingcraftsman.in/2012/09/binding-for-knockoutjs
ko.bindingHandlers.shortcut = {
    init: function (element: HTMLElement, valueAccessor, allBindings, viewModel, bindingContext) {

        const event = (e) => {

            const method = ko.unwrap(valueAccessor())
            method(viewModel, e);
        }
        element.addEventListener('keydown', event)

        ko.utils.domNodeDisposal.addDisposeCallback(element, event)

    }


};